/** @jsx jsx */

import { upperFirst } from 'lodash';

import { Colors, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import DrillDownListItem from 'app/developer-v3/components/DrillDownListItem';
import { useToggle } from 'app/developer-v3/hooks';

const Styles = {
  root: css`
    cursor: pointer;
    margin-bottom: 5px;
    border: 1px solid ${Colors.GrayWarm4};
    border-radius: 5px;

    :hover,
    :focus {
      background-color: ${Colors.GrayWarm2};
      color: ${Colors.UiPrimaryStrongest};
    }
  `,
};

type Props = {
  message: string;
  onClick: () => void;
};

export default function DetailItem({ onClick, message }: Props) {
  const [isToggleOn, toggle] = useToggle(false);

  return (
    <div
      css={Styles.root}
      onBlur={toggle}
      onFocus={toggle}
      onMouseOut={toggle}
      onMouseOver={toggle}
    >
      <DrillDownListItem isSmall={true} onClick={onClick}>
        <Text color={isToggleOn ? 'inherit' : undefined}>
          {upperFirst(message)}
        </Text>
      </DrillDownListItem>
    </div>
  );
}
